module.exports = __webpack_public_path__ + "static/img/aikucun.c29c19b0.png";